import { createSelector } from 'reselect'

export const getEmployer$ = createSelector(
  state => state.employers,
  (_, id) => id,
  (employersState, id) => employersState?.entityMap[id],
)
